import { FormattedMessage } from 'react-intl';
import { SegmentedControl } from '@mantine/core';

import { FlexColumn, Gap } from 'ui-components/components/flex';

import { useEnableCustomsTabView } from '../../../../../feature-flags/hooks/use-enable-customs-tab-view';
import { useCustomsContext } from '../../../context/context';
import { DeclarationsList } from './declarations-list/declarations-list';
import { DeclarationsTabs } from './declarations-tabs/declarations-tabs';
import { CustomsViewMode, useCustomsViewMode } from './use-customs-view-mode';

import { messages } from './messages';

export type CustomsDeclarationsSectionType = {
  readOnly?: boolean;
};

export const CustomsDeclarationsSection = ({ readOnly }: CustomsDeclarationsSectionType) => {
  const { customsItems = [] } = useCustomsContext();
  const { viewMode, handleChangeViewMode } = useCustomsViewMode();
  const enableCustomsTabView = useEnableCustomsTabView();

  if (customsItems.length === 0) {
    return null;
  }

  if (!enableCustomsTabView) {
    return <DeclarationsList readOnly={readOnly} />;
  }

  const SectionComponent = viewMode === CustomsViewMode.Tab ? DeclarationsTabs : DeclarationsList;

  return (
    <FlexColumn gap={Gap.Space8}>
      <SegmentedControl
        data={[
          { label: <FormattedMessage {...messages.listViewButton} />, value: CustomsViewMode.List },
          { label: <FormattedMessage {...messages.tabViewButton} />, value: CustomsViewMode.Tab },
        ]}
        onChange={handleChangeViewMode}
        value={viewMode}
      />

      <SectionComponent readOnly={readOnly} />
    </FlexColumn>
  );
};
